import apiClient from "./apiClient";

export const login = (formData) => apiClient.post("/login", formData);

export const logout = (formData) => apiClient.post("/logout", formData);